import React from 'react';

const Table = () => (
  <table className='table-auto border-separate text-base bg-gray-100 text-center'>
    <thead>
      <tr className='bg-green-200'>
        <th>CLARENCETOWN VO unit</th>
        <th>kWh</th>
        <th>KVA MD</th>
        <th>AVG PF</th>
      </tr>
    </thead>
    <tbody>
      <tr className="bg-white">
        <td>BEFORE VO</td>
        <td>135,550 </td>
        <td>95.49</td>
        <td> 0.797 </td>
      </tr>
      <tr className="bg-white">
        <td>AFTER VO</td>
        <td> 116,015 </td>
        <td>83.80</td>
        <td>0.842</td>
      </tr>
      <tr className="bg-white">
        <td>SAVING/IMPROVEMENT</td>
        <td>14.4%</td>
        <td>12.2%</td>
        <td>5.7%</td>
      </tr>
    </tbody>
  </table>
);

export default Table;
